import { module } from 'modujs';
import { Controller, Navigation, Swiper } from 'swiper';

export default class SliderFancy extends module {

    static get settings() {
        return {
            MOBILE_BREAKPOINT: 700,
        }
    }

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$prev = this.$('prev')[0]
        this.$next = this.$('next')[0]
        this.$sliderMain = this.$('sliderMain')[0]
        this.$sliderPrev = this.$('sliderPrev')?.[0]
        this.$sliderNext = this.$('sliderNext')?.[0]
        this.breakpoint = window.matchMedia(`(min-width: ${SliderFancy.settings.MOBILE_BREAKPOINT}px)`)

        // Vars
        this.TOTAL_SLIDES = this.getData('slides-count')

        // Options
        this.options = {
            loop: true,
            modules: [ Controller, Navigation ],
            navigation: {
                prevEl: this.$prev,
                nextEl: this.$next,
            },
            slidesPerView: 'auto',
            speed: 700,
        }

        // Binding
        this.onBreakPointChangeBind = this.onBreakPointChange.bind(this)

        // Events
        this.events = {
            click: {
                sliderPrev: 'prev',
                sliderNext: 'next',
            }
        }
    }

    init() {
        this.bindEvents()

        // Init
        this.onBreakPointChange()
    }

    onBreakPointChange() {

        // Destroy sliders
        this.swiper?.destroy()
        this.swiperPrev?.destroy()
        this.swiperNext?.destroy()

        if (this.breakpoint.matches === true && this.$sliderPrev && this.$sliderNext) {

            const options = {
                ...this.options,
                allowTouchMove: false,
            }

            this.swiperPrev = new Swiper(this.$sliderPrev, options)
            this.swiperNext = new Swiper(this.$sliderNext, options)
            this.swiper = new Swiper(this.$sliderMain, options)

            this.swiperPrev.slideTo(0)
            this.swiper.slideTo(1 % this.TOTAL_SLIDES)
            this.swiperNext.slideTo(2 % this.TOTAL_SLIDES)

        } else if (this.breakpoint.matches === false) {
            this.swiper = new Swiper(this.$sliderMain, this.options)
        }
    }

    prev() {
        this.$prev.click()
    }

    next() {
        this.$next.click()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        if ('addEventListener' in this.breakpoint) {
            this.breakpoint.addEventListener('change', this.onBreakPointChangeBind)
        } else if ('addListener' in this.breakpoint) {
            this.breakpoint.addListener(this.onBreakPointChangeBind)
        }
    }

    unbindEvents() {
        if ('removeEventListener' in this.breakpoint) {
            this.breakpoint.removeEventListener('change', this.onBreakPointChangeBind)
        } else if ('removeListener' in this.breakpoint) {
            this.breakpoint.removeListener(this.onBreakPointChangeBind)
        }
    }

    destroy() {
        this.unbindEvents()

        this.swiper?.destroy()
        this.swiperPrev?.destroy()
        this.swiperNext?.destroy()

        super.destroy()
    }
}
